// @ts-strict-ignore
import { AfterViewInit, Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { SohoAlertDirective } from 'ids-enterprise-ng';
import { LMGlobalPersonalizationService } from '@app/states';
import { LMConfigurationService } from '@app/services';
import {
  LMFieldPickerIncludeOptions,
  LMFieldPickerResponse,
  LMFieldPickerSelectOptions,
  LMFieldPickerSelectResponse
} from '@modal/field-picker/lm-field-picker';
import { LMFieldPickerService } from '@app/components';
import { LMFieldValidatorService } from '@modal/lm-field-validator.service';
import { Observable, of } from 'rxjs';

@Component({
  selector:     'lm-add-total-dialog',
  templateUrl:  'lm-add-total-dialog.component.html',
  styleUrls:    [ 'lm-add-total-dialog.component.scss' ],
})

export class LMAddTotalDialogComponent implements OnInit, AfterViewInit {
  @ViewChildren(SohoAlertDirective) alerts: QueryList<SohoAlertDirective>;

  @Input() request: LMAddTotalRequest;

  totalFieldAlert: SohoAlertDirective;

  useCompactFormLayout = false;
  totalType: SummaryFieldType = 'sum';
  useExplicitLabel: boolean;
  explicitLabel: string;
  totalField: string


  constructor(
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private lmConfigurationService: LMConfigurationService,
    private lmFieldValidatorService: LMFieldValidatorService,
    private lmFieldPickerService: LMFieldPickerService) {
  }

  ngOnInit() {
    this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout;
  }

  ngAfterViewInit() {
    this.totalFieldAlert = this.alerts.find((alert: SohoAlertDirective) => (alert.elementRef.nativeElement as Element).getAttribute('id') === 'lm-add-total-field');
  }

  openFieldPicker() {
    const options: LMFieldPickerSelectOptions = {
      view: 'Fields',
      businessClass: this.request.businessClass,
      enableOperatorBuilder: false,
      includeAuditFields: false
    };
    this.lmFieldPickerService.openFieldPickerDialog(options, this.request.fieldLookupUrl, undefined)
      .subscribe((result) => {
        this.handleFieldResponse(result);
      });
  }

  autoCompleteSource = ((searchTerm: string, response: SohoAutoCompleteResponseFunction) => {
    const url = this.request.fieldLookupUrl;
    let includeOptions;

    switch (this.totalType) {
      case 'min':
      case 'max':
        includeOptions = new Array<LMFieldPickerIncludeOptions>();
        includeOptions.push('onlyNumberFields');
        includeOptions.push('onlyDateFields');
        break;
      case 'avg':
      case 'sum':
        includeOptions = new Array<LMFieldPickerIncludeOptions>();
        includeOptions.push('onlyNumberFields');
        break;
    }

    this.lmConfigurationService.searchField(searchTerm, url, this.request.businessClass, 'Fields', includeOptions)
      .subscribe((fieldPickerResponse: LMFieldPickerResponse) => {
        setTimeout(() => {
          let uiFieldSpecNames;
          if (fieldPickerResponse.data) {
            uiFieldSpecNames = fieldPickerResponse.data.map(uiFieldSpec => this.lmFieldPickerService.getUIFieldSpecSearchName(uiFieldSpec));
            response(searchTerm, uiFieldSpecNames);
          }
        }, 1);
      });
  })

  validateField() {
    // Timeout need to avoid have in error when the user picks the value from
    // the values in the autocompletion list!
    setTimeout(() => this._validateField().subscribe());
  }

  public onDialogSubmit(): Observable<boolean> {
    return this.validateForm();
  }

  public getResponse(): LMAddTotalResponse {
    let fieldId: string = this.totalType;

    if (this.totalType !== 'instance count') {
      fieldId = fieldId + ' ' + this.totalField;
    }

    const label = this.useExplicitLabel ? this.explicitLabel : undefined;

    const summaryTotalField: LMSummaryTotalField = {
      index: Date.now(),
      added: true,
      fieldId,
      label
    };

    return { summaryTotalField };
  }

  private validateForm(): Observable<boolean> {
    if (this.totalType === 'instance count') {
      return of(true);
    } else if (!this.totalField || this.totalField.trim().length === 0) {
      this.totalFieldAlert?.removeAllMessages();
      this.totalFieldAlert?.addInlineMessage(Soho.Locale.translate('Required'), 'error', true, false);
      return of(false);
    } else {
      return this._validateField();
    }
  }

  private _validateField(): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.totalFieldAlert?.removeAllMessages();
      if (this.totalField && this.totalField.trim().length > 0 ) {
        this.lmFieldValidatorService.fieldIsValid(
          this.totalField,
          this.request.businessClass,
          this.request.listName,
          this.request.fieldValidationUrl).subscribe(response => {
          if(response?.lplStatus === 'LPL_VALID') {
            observer.next(true);
          } else {
            this.totalFieldAlert?.addInlineMessage(Soho.Locale.translate('ListPersonalizationAddFieldErrorMessage'), 'error', true, false);
            observer.next(false);
          }
          observer.complete();
        });
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }

  private handleFieldResponse(response: LMFieldPickerSelectResponse) {
    if (response === undefined) {
      return;
    }

    this.totalField = response.fieldName;
  };


}
//Andrew questions
// Be sure to allow to add a inine compute total

